/**
 * GraphQL query for assigning moderation cases to a moderator.
 *
 * When filterId is provided, only cases matching the ABR filter are returned.
 * When omitted, all cases in the topic queue are returned (existing behavior).
 */

import { gql } from '@apollo/client';

export const ASSIGN_MODERATION_CASE = gql`
  query AssignModerationCase($communityId: ID!, $topicName: String!, $filterId: ID) {
    assignModerationCase(communityId: $communityId, topicName: $topicName, filterId: $filterId) {
      id
      communityId
      topicName
      subjectId
      caseId
      pk
      report {
        communityId
        topicName
        subjectId
        timestamp
        feedbackComment
        feedbackLabels
        customValues {
          key
          value
        }
        contents {
          contentId
          contentType
          data
          humanModerationViewHeader
          labels {
            labels {
              name
              confidence
            }
            source
          }
        }
        reportSource {
          id
          type
        }
        subjectOwner {
          id
          type
          additionalInfo {
            key
            value
          }
        }
      }
      status
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
